// Grouped under Teacher; preserve the original page URLs.
export default [{
  path: '/expertReview/services',
  component: function component() {
    return import('@/views/expertReview/services');
  },
  name: 'ExpertReviewServices',
  meta: {
    title: '点评服务'
  }
}, {
  path: '/expertReview/orders',
  component: function component() {
    return import('@/views/expertReview/orders');
  },
  name: 'ExpertReviewOrders',
  meta: {
    title: '点评订单'
  }
}, {
  path: '/expertReview/disputes',
  component: function component() {
    return import('@/views/expertReview/disputes');
  },
  name: 'ExpertReviewDisputes',
  meta: {
    title: '点评争议'
  }
}, {
  path: '/expertReview/results',
  component: function component() {
    return import('@/views/expertReview/results');
  },
  name: 'ExpertReviewResults',
  meta: {
    title: '点评结果'
  }
}, {
  path: '/expertReview/feedback',
  component: function component() {
    return import('@/views/expertReview/feedback');
  },
  name: 'ExpertReviewFeedback',
  meta: {
    title: '评价管理'
  }
}, {
  path: '/expertReview/refunds',
  component: function component() {
    return import('@/views/expertReview/refunds');
  },
  name: 'ExpertReviewRefunds',
  meta: {
    title: '退款管理'
  }
}, {
  path: '/expertReview/settlements',
  component: function component() {
    return import('@/views/expertReview/settlements');
  },
  name: 'ExpertReviewSettlements',
  meta: {
    title: '收入对账'
  }
}, {
  path: '/expertReview/performance',
  component: function component() {
    return import('@/views/expertReview/performance');
  },
  name: 'ExpertReviewPerformance',
  meta: {
    title: '履约统计'
  }
}];